import React, { memo } from 'react';
import Panel from '../../../../components/outline/Panel';
import Table from '../../../../components/_table/Table/Table';
import { columns } from './columns';

const PointReferralIssueList = (props) => {
  const { pointReferralIssueList, getList, pagination, sortOption } = props;

  return (
    <div className="point-referral-issue-list">
      <Panel>
        <div className="panel-body">
          <Table
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
            rowKey={(record) => record.id}
            pagination={pagination}
            sortOption={sortOption}
            list={pointReferralIssueList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    </div>
  );
};

export default memo(PointReferralIssueList);
